import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import Inicio from './pages/Inicio';
import Estoque from './pages/Estoque';
import Contato from './pages/Contato';
import Veiculos from './pages/Veiculos';
import Financiamento from './pages/Financiamento';
import VendaSeuVeiculo from './pages/VendaSeuVeiculo';
import VeiculosKar from './revendas/Veiculos_Kar';
import VeiculosB8 from './revendas/Veiculos_B8';
import VeiculosMeA from './revendas/Veiculos_M&A';
import Veiculos_Garage from './revendas/Veiculos_Garage';
import VeiculosMaverick from './revendas/Veiculos_Maverick';
import VeiculosDcar from './revendas/Veiculos_Dcar';
import VeiculosTopCristal from './revendas/Veiculos_TopCristal';
import VeiculosDuarte from './revendas/Veiculos_Duarte';
import VeiculosFrMultimarcas from './revendas/Veiculos_FrMultimarcas';
import VeiculosFlap from './revendas/Veiculos_Flap';
import VeiculosGrs from './revendas/Veiculos_Grs';



class App extends Component {
  render(){
    return (
      <Router>
          <Switch>  
              <Route path='/' exact component={Inicio} />  
              <Route path='/veiculos/:idVeiculo' component={Veiculos} />
              <Route path='/veiculo_kar/:idVeiculo' component={VeiculosKar}/>
              <Route path='/veiculo_b8/:idVeiculo' component={VeiculosB8}/>
              <Route path='/veiculo_mea/:idVeiculo' component={VeiculosMeA}/>
              <Route path='/veiculo_garage/:idVeiculo' component={Veiculos_Garage}/>
              <Route path='/veiculo_dcar/:idVeiculo' component={VeiculosDcar}/>
              <Route path='/veiculo_maverick/:idVeiculo' component={VeiculosMaverick}/>
              <Route path='/veiculo_topcristal/:idVeiculo' component={VeiculosTopCristal}/>
              <Route path='/veiculo_duarte/:idVeiculo' component={VeiculosDuarte}/>
              <Route path='/veiculo_fr/:idVeiculo' component={VeiculosFrMultimarcas}/>
              <Route path='/veiculo_grs/:idVeiculo' component={VeiculosGrs}/>
              <Route path='/veiculo_flap/:idVeiculo' component={VeiculosFlap}/>
              <Route path='/contato' component={Contato} />                  
              <Route path='/financiamento' component={Financiamento} />                  
              <Route path='/estoque' component={Estoque} />                  
              <Route path='/vendaseuveiculo' component={VendaSeuVeiculo} />         
              <Route path='/:idempresa' component={Inicio} />         
          </Switch> 
      </Router>
    );
  }
}

export default App;
